/* global gapi */
const reportCache = {};
const timeBetweenStartOfRequests = 300; // milliseconds
const charts = require('../charts/charts');

const checkEmptyModuleSection = require('../review/checkEmptyModules');

function renderChart (part, data) {
  let $part = $(part);
  $part.addClass('rendered');
  $part.addClass('renderedandy');

  const type = $part.data('type');
  $part.html('');

  switch (type) {
    case 'line-chart':
      return charts.line($part, data);
    case 'line-time':
      return charts.lineTime($part, data);
    case 'geo':
      return charts.geo($part, data);
    case 'pie':
      return charts.pie($part, data);
    case 'gender-age-chart':
      return charts.genderAge($part, data);
    default:
      return charts.render($part, data, type);
  }
}

function createTable ({response, labels, part}) {
  const starHtml = `
<svg role="img" class="icon icon-star icon-xs fill-primary">
  <use xlink:href="#star"></use>
</svg>
  `;
  let div = document.createElement('div');
  div.innerHTML = starHtml.trim();
  const starElement = div.firstChild;

  let tbl = document.createElement('table');
  tbl.classList.add('table');
  tbl.classList.add('table-thinhead');
  tbl.classList.add('backlinks-traffic-domain');
  const classes = [
    [],
    ['text-right'],
    ['stars', 'column-rating']
  ];

  let thead = document.createElement('thead');
  let tr = document.createElement('tr');
  for (let i = 0; i < labels.length; i++) {
    let labelText = labels[i];
    let th = document.createElement('th');
    th.appendChild(document.createTextNode(labelText));
    let classList = classes[i];
    th.classList.add(...classList);
    tr.appendChild(th);
  }
  thead.appendChild(tr);
  tbl.appendChild(thead);

  let tbody = document.createElement('tbody');
  (response.rows || [])
    .slice(0, 20)
    .map(([source, sessions, bounceRate, avgSessionDuration, pageviewsPerSession]) => {
      let tr = document.createElement('tr');
      let td = document.createElement('td');
      td.appendChild(document.createTextNode(source));
      tr.appendChild(td);

      td = document.createElement('td');
      td.classList.add('text-right');
      td.appendChild(document.createTextNode(sessions));
      tr.appendChild(td);

      td = document.createElement('td');
      td.classList.add('stars');
      td.classList.add('column-rating');
      for (let i = 0; i < Math.min(3, pageviewsPerSession); i++) {
        td.appendChild(starElement.cloneNode(true));
      }
      tr.appendChild(td);
      tbody.appendChild(tr);
    });
  tbl.appendChild(tbody);
  const wrapper = document.createElement('div');
  wrapper.classList.add('part');
  wrapper.classList.add('table');
  wrapper.appendChild(tbl);
  part.append(wrapper);
}

function genChart (chartsToRender, i = 0) {
  if (i === chartsToRender.length) {
    return;
  }

  setTimeout(function () {
    let $part = $(chartsToRender[i]);
    const query = $part.data('query');
    const labels = $part.data('labels');
    const accessToken = $part.data('access');
    const name = $part.data('name');
    requestGaData(query, accessToken, name, labels, $part);
    genChart(chartsToRender, ++i);
  }, timeBetweenStartOfRequests);
}

function transformDataAndGenerateChart () {
  if ($('.js-regenerate').hasClass('busy') || $('.js-regenerate').hasClass('disabled')) {
    return;
  }
  const chartsToRender = $('.part.ga-chart:not(.rendered)');
  genChart(chartsToRender);
}

function handleError (err, part) {
  const expectedErrors = [
    'no_ga_data',
    'no_graph_data',
    'no_graph_type',
    'User does not have sufficient permissions for this profile.'
  ];
  part.closest('.criterium').remove();
  checkEmptyModuleSection();
  if (!expectedErrors.includes(err.message)) {
    throw err;
  }
}

function renderReport (response, query, accessToken, name, labels, part) {
  function gaDateToTimestamp (gaDate) {
    const year = gaDate.substring(0, 4);
    const month = gaDate.substring(4, 6);
    const day = gaDate.substring(6, 8) || '01';
    return Date.parse(`${year}-${month}-${day}T00:00:00.000+00:00`);
  }
  function sortResBySource (response, maxResults = 5) {
    const sortByFirstArrayValue = (a, b) => a[0] - b[0];
    const bySource = (response.rows || [])
      .reduce((acc, [date, source, visitors]) => {
        if (acc[source] === undefined) {
          acc[source] = [];
        }
        acc[source].push([gaDateToTimestamp(date), Number(visitors)]);
        return acc;
      }, {});
    const graphFormat = Object.entries(bySource)
      .slice(0, maxResults)
      .map(([source, data]) => ({ name: source, data: data.sort(sortByFirstArrayValue).slice(1, -1) }));
    return graphFormat;
  }
  function prepareForGeoMap (data) {
    const maxCountriesToDisplay = 25;
    const geoData = (response.rows || [])
      .slice(0, maxCountriesToDisplay)
      .reduce((acc, [countryIsoCode, visitors]) => {
        acc[countryIsoCode.toLowerCase()] = Number(visitors);
        return acc;
      }, {});
    return geoData;
  }
  const dimensions = response.columnHeaders.filter(v => v.columnType === 'DIMENSION');
  const graph = document.getElementsByClassName(`ga-graph-${name}`)[0];
  if (!graph) {
    return handleError(new Error('no_graph_type'), part);
  }
  const graphType = graph.getAttribute('data-type');
  let graphData = [];

  if (graphType === 'geo') {
    graphData = prepareForGeoMap(response);
  } else if (dimensions.length === 1) {
    let visitorsData = (response.rows || [])
      .map(([date, visitors, newVisitors]) => ([gaDateToTimestamp(date), Math.round(Number(visitors) * 100) / 100]));
    const newVisitorsData = (response.rows || [])
      .map(([date, visitors, newVisitors]) => ([gaDateToTimestamp(date), Math.round(Number(newVisitors) * 100) / 100]));
    graphData = [
      { name: labels[0], data: visitorsData.slice(1, -1) },
      { name: labels[1], data: newVisitorsData.slice(1, -1) }
    ]
      .filter(v => v.name !== undefined);
    if (graphType === 'line-time') {
      visitorsData = visitorsData.map(([timestamp, timeOnSiteInSeconds]) =>
        [timestamp, Math.round(timeOnSiteInSeconds * 1000)]);
      graphData[0].data = visitorsData;
    }
  } else {
    graphData = sortResBySource(response);
  }
  graph.children[0].innerHTML = JSON.stringify(graphData);
  if (graphType === 'traffic-table') {
    graph.classList.add('rendered');
    createTable({response, labels, part});
  } else {
    renderChart(part, graphData);
  }
}

function requestGaData (query, accessToken, name, labels, part) {
  const cacheKey = JSON.stringify({query, name, labels, part});
  labels = labels.length === 0 ? ['Visitors', 'New Visitors'] : labels;
  if (reportCache[cacheKey]) {
    return renderReport(reportCache[cacheKey], query, accessToken, name, labels, part);
  }

  gapi.analytics.ready(function () {
    gapi.analytics.auth.authorize({
      serverAuth: {
        access_token: accessToken
      }
    });

    const report = new gapi.analytics.report.Data({ query });
    report.on('success', function (response) {
      if (response.totalResults === 0) {
        return handleError(new Error('no_ga_data'), part);
      }
      reportCache[cacheKey] = response;
      renderReport(response, query, accessToken, name, labels, part);
    });
    report.on('error', function (response) {
      return handleError(response.error, part);
    });
    report.execute();
  });
}

module.exports = transformDataAndGenerateChart;
